import { ReactComponent as FilterIcon } from "../svgs/FilterIcon.svg";
import { ReactComponent as CloseIcon } from "../svgs/CloseIcon.svg";
import styled from "styled-components";

export const FilteringBarContainer = styled.div`
  margin-bottom: 0;
`;

export const FilterSidebarContainer = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  height: 100%;
  width: max-content;
  background: var(--color-white);
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
  transform: translateX(${props => (props.isOpen ? "0" : "-100%")});
  transition: transform 0.3s ease-in-out;
  z-index: 1000;
  padding: 1rem 2rem;
  margin-top: 4rem;
  overflow-y: auto;
`;

export const FilterIconStyled = styled(FilterIcon)`
  height: 3rem;
  width: 3rem;
  padding: 0.5rem;
  transition: all 150ms;
  border: 1px solid black;
  border-radius: 0.375rem;
  &:hover {
    border-color: var(--filter-button-hovered-color);
    & * {
      fill: var(--filter-button-hovered-color);
    }
  }
`;

export const FilterButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
`;

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  justify-self: flex-end;
  margin-left: auto;
  padding-bottom: 1rem;
`;

export const CloseIconStyled = styled(CloseIcon)`
  height: 2.5rem;
  width: 2.5rem;
  padding: 0.5rem;
  & * {
    fill: var(--button-primary-color);
  }
`;

export const MainLayout = styled.div`
  display: flex;
  margin-left: ${props => (props.sidebarOpen ? "225px" : "0")};
  width: ${props => (props.sidebarOpen ? "calc(100% - 225px)" : "100%")};
  transition: all 0.3s ease-in-out;
`;
